// biome-ignore lint/style/noRestrictedImports: encapsulation
import { cva } from "class-variance-authority";

import type { Compute } from "~/tools/compute";
import type { Object } from "~/tools/object";
import type { Optional } from "~/tools/optional";

// biome-ignore lint/style/noRestrictedImports: re-export
// biome-ignore lint/performance/noBarrelFile: re-export
export { type VariantProps as X, cx } from "class-variance-authority";

export type VariantProp<
	TComponent extends (props: Object) => unknown,
	TProp extends keyof NonNullable<Parameters<TComponent>[0]>,
> = NonNullable<Parameters<TComponent>[0][TProp]>;

export type VariantProps<TComponent extends (props: Object) => unknown> = Partial<
	Omit<NonNullable<Parameters<TComponent>[0]>, "className">
>;

// enforce all variants to be defined
export type Props<T> = Compute<
	NonNullable<Omit<Optional<NonNullable<Parameters<ReturnType<typeof cva<T>>>[0]>>, "class">>
>;

export const cv = cva as <T>(...args: Parameters<typeof cva<T>>) => (props: Props<T>) => string;
